var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-breadcrumbs',{staticClass:"px-0 py-2",attrs:{"items":_vm.breadcrumbs}}),_vm._v(" "),_c('v-row',[_c('v-col',[(_vm.user)?_c('user-form',{attrs:{"user":_vm.user,"is-edit":true}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }